export default __webpack_public_path__ + "static/media/acq_preview_m.284ede3b.png";